import React from 'react';

export const ViewActivity = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_37124_121705)">
      <path
        d="M8 5.33398V8.00065L9.33333 9.33398"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 7.39197C2.14939 5.92534 2.83351 4.56505 3.92182 3.57062C5.01014 2.57619 6.42646 2.01723 7.90059 2.00039C9.37471 1.98355 10.8034 2.51001 11.9142 3.47933C13.0249 4.44864 13.7399 5.79296 13.9228 7.25579C14.1056 8.71863 13.7435 10.1976 12.9056 11.4105C12.0676 12.6234 10.8124 13.4853 9.37952 13.8319C7.94661 14.1784 6.43627 13.9853 5.13666 13.2894C3.83705 12.5934 2.83915 11.4434 2.33333 10.0586M2 13.392V10.0586H5.33333"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_37124_121705">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
